import React from 'react';
import BusRouteAnalyzer from './BusRouteAnalyzer';

function App() {
  return (
    <div className="App">
      <BusRouteAnalyzer />
    </div>
  );
}

export default App;
